import { TweenMax, TweenLite, CSSPlugin } from 'gsap';

/*
 * Menu class
 */
class Menu{
	/**
	 * Constructor
	 */
	constructor(){
		// properties
		this.height = 0;
		this.toggler = document.getElementById('nav-toggle');
		this.content = document.getElementById('site-nav');
		this.open = false;

		// @TODO: reinit menu display on window resize
		this.initDisplay();

		let self = this;
		self.toggler.addEventListener('click', function(){
			self.toggle(self.toggler);
		});
	}

	/**
	 * Init properties depending on display context
	 */
	initDisplay() {
		var self = this;
		self.content.style.opacity = 0;
		self.content.style.height= "auto";
		self.height = self.content.offsetHeight;
		self.content.style.height= 0;
		self.content.style.opacity = 1;
	}

	/**
	 * Toggle menu display
	 */
	toggle(toggler) {
		let content = document.getElementById('site-nav');
		if (this.open) {
			TweenLite.to(content, 0.2, {height:0});
			this.open = false;
		} else {
			TweenLite.set(content, {height:"auto"});
			TweenLite.from(content, 0.3, {height:0});
			this.open = true;
    }
	}
}

export default Menu;
